import { Component } from '@angular/core';
import { PagingResponse } from "@models/paging-response.model";
import { LexbeDoc } from "@models/doc.model";
import { DocService } from "@services/doc.service";
import { takeUntil } from "rxjs/operators";
import { BaseComponent } from "../../../base.component";
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { LexbeDocToDocViewerContextDocMapper } from '@models/mappers/doc-viewer/lexbe-doc-to-doc-viewer-context-model.mapper';
import { DocumentConextListState } from '@store/doc-viewer/document-list/document-list.state';

@Component({
    selector: 'lex-exact-duplicate-context-panel',
    templateUrl: './exact-duplicate-context-panel.component.html',
    styleUrls: ['./exact-duplicate-context-panel.component.scss'],
    standalone: false
})
export class ExactDuplicateContextPanelComponent extends BaseComponent {
	public currentDocumentSnapshot: LexbeDoc;
	public docListContext: DocumentConextListState = {
		docList: [],
		isExpandedResults: false
	};
	private mapper: LexbeDocToDocViewerContextDocMapper = new LexbeDocToDocViewerContextDocMapper();

	constructor(
		private docService: DocService,
		private docViewerStore: DocViewerStore,
	) {
		super();

		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe((snapshot) => this.currentDocumentSnapshot = snapshot);

		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe(() => this.loadExactDup());
	}

	public get hasData() {
		return this.docListContext && this.docListContext.docList.length > 0;
	}

	private loadExactDup() {
		if (this.currentDocumentSnapshot.dedupFamilyId === '00000000-0000-0000-0000-000000000000') {
			this.docListContext = null;
			return;
		}

		this.docService.getExactDupDocs(this.currentDocumentSnapshot.dedupFamilyId, this.currentDocumentSnapshot.common.dedupHash)
			.subscribe((docs: PagingResponse<LexbeDoc>) => {
				this.docListContext = {
					...this.docListContext,
					docList: this.mapper.mapCollection(docs.value)
				};
			});
	}
}
